<agr-page-toolbar
  [pageTitle]="'salesPotential.title' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'salesPotential.addCrop' | translate"
  (primaryAction)="onAddCrop()"
  [selectItems]="selectItems$ | async"
  (selectAction)="selectAction($event)"
>
  <div class="spacing--padding-all">
    <div class="sales-potential-table-container">
      @if ((salesPotentialData$ | async)?.length === 0) {
        <div class="empty-state">
          <mat-icon class="empty-state-icon">info</mat-icon>
          <p>{{ 'salesPotential.noSalesPotentialsFound' | translate }}</p>
        </div>
      } @else {
        <table mat-table [dataSource]="salesPotentialData$ | async" class="sales-potential-table">
          <!-- Crop Column -->
          <ng-container matColumnDef="crop">
            <th mat-header-cell *matHeaderCellDef>{{ 'salesPotential.cropColumn' | translate }}</th>
            <td mat-cell *matCellDef="let element">{{ element.crop }}</td>
          </ng-container>
          <!-- Hectare Column -->
          <ng-container matColumnDef="hectare">
            <th mat-header-cell *matHeaderCellDef>{{ 'salesPotential.areaColumn' | translate }}</th>
            <td mat-cell *matCellDef="let element">{{ element.hectare | number: '1.2-2' }}</td>
          </ng-container>
          <!-- GBM Column -->
          <ng-container matColumnDef="gbm">
            <th mat-header-cell *matHeaderCellDef>{{ 'salesPotential.gbm' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              @if (element.gbm) {
                <mat-icon class="checkmark-icon">check</mat-icon>
              }
            </td>
          </ng-container>
          <!-- Fertilizer Column -->
          <ng-container matColumnDef="fertilizer">
            <th mat-header-cell *matHeaderCellDef>{{ 'salesPotential.fertilizer' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              @if (element.bemesting) {
                <mat-icon class="checkmark-icon">check</mat-icon>
              }
            </td>
          </ng-container>
          <!-- Seed Column -->
          <ng-container matColumnDef="seed">
            <th mat-header-cell *matHeaderCellDef>{{ 'salesPotential.seed' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              @if (element.zaaigoed) {
                <mat-icon class="checkmark-icon">check</mat-icon>
              }
            </td>
          </ng-container>
          <!-- IsSkal Column -->
          <ng-container matColumnDef="isSkal">
            <th mat-header-cell *matHeaderCellDef>{{ 'salesPotential.organic' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              @if (element.isSkal) {
                <mat-icon class="checkmark-icon">check</mat-icon>
              }
            </td>
          </ng-container>
          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="actions-cell">
              <button
                mat-icon-button
                (click)="onEditRow(element)"
                class="action-button"
                [attr.aria-label]="'edit' | translate"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                (click)="onDeleteRow(element)"
                class="action-button"
                [attr.aria-label]="'delete' | translate"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <!-- Header and Body -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      }
    </div>
  </div>
</agr-page-toolbar>
